import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=c1860462&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Index.vue?vue&type=style&index=1&id=c1860462&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1860462",
  null
  
)

export default component.exports